<template>
  <div class="selectors">
    <div v-if="tab === 'shirts'" class="selectors__item">
      <ShirtsSelector />
    </div>
    <div v-if="tab === 'pants'" class="selectors__item">
      <PantsSelector />
    </div>
    <div v-if="tab === 'cap'" class="selectors__item">
      <CapSelector />
    </div>
    <div v-if="tab === 'emblem'" class="selectors__item">
      <EmblemSelector />
    </div>
    <div v-if="tab === 'mark'" class="selectors__item">
      <MarkSelector />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShirtsSelector from './selectors/ShirtsSelector'
import PantsSelector from './selectors/PantsSelector'
import CapSelector from './selectors/CapSelector'
import EmblemSelector from './selectors/EmblemSelector'
import MarkSelector from './selectors/MarkSelector'
export default {
  components: {
    ShirtsSelector,
    PantsSelector,
    CapSelector,
    EmblemSelector,
    MarkSelector,
    
  },
  computed: {
    ...mapState({
      tab: state => state.current.tab,
    })
  },
}
</script>